import {
  AlertDialogHeader as ChakraAlertDialogHeader,
  ModalHeaderProps as ChakraModalHeaderProps,
} from '@chakra-ui/react';
import { specialFont } from 'constants/theme';

const AlertDialogHeader = (props: ChakraModalHeaderProps) => (
  // Workaround for styles not supported
  <ChakraAlertDialogHeader
    fontFamily={specialFont}
    fontSize="4xl"
    fontWeight="medium"
    letterSpacing="wide"
    {...props}
  />
);

export { AlertDialogHeader };
